<template>
    <div>
        <BaseModal
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="windowTitle"
            :width="'50%'"
            :height="'390px'"
            :buttons="buttons"
            @Close="close"
        >
            <b-row>
                <b-col lg="12" md="12" sm="12">
                    <MdMemo
                        v-bind:Name="'comments'"
                        v-bind:Rows="'14'"
                        v-bind:isAutoFocus="true"
                        v-bind:MaxRows="'14'"
                        v-model="notes"
                        :isRequired="required"
                        ,
                        :isReadOnly="isReadOnly"
                    />
                </b-col>
            </b-row>
        </BaseModal>
    </div>
</template>

<script>
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'MDTextEditorDialog',
    mixins: [validationMixin, ShowMessage],

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: true
        },
        handlerOk: {
            type: Function,
            required: true
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        },
        buttonSaveHidden: {
            Type: Boolean,
            default: false
        },
        title: {
            Type: String,
            default: null
        }
    },

    data() {
        return {
            modalId: 'TextEditorId',
            notes: this.value
        };
    },

    computed: {
        buttons() {
            if (this.buttonSaveHidden) {
                return [
                    { text: this.$t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' }
                ];
            }

            return [
                { text: this.$t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: this.$t('Shared.Save'), variant: 'primary', action: this.emitEventOK }
            ];
        },

        windowTitle() {
            return this.title || this.$tc('Shared.Note', 2);
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.emitCloseEvent = true;
            }
        },
        value(newVal) {
            this.notes = newVal;
        }
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent = false;
            this.$emit('close');
        },

        emitEventOK() {
            if (this.validate()) {
                this.$emit('input', this.notes);
                this.handlerOk(this.notes);
                this.$emit('ok');
            } else {
                if (!this.isValid('comments')) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.invalidMessage('comments'),
                        'errorAutoHide'
                    );
                }
            }
        },

        onHidden() {
            this.notes = '';
            this.$emit('input', this.notes);

            if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent = false;
            }
        },

        validate() {
            if (this.required) {
                const rules = {
                    comments: [validationRules.required(this.$t('PharmacyNotes.NotesRequired'))]
                };

                return this.validateFields(rules, { comments: this.notes });
            }

            return true;
        },

        close() {
            this.emitEventCancel();
        }
    }
};
</script>
